module.exports = __webpack_public_path__ + "static/media/text_search.c265a7a7.svg";